import "./Styles/listing-events.scss";
import "react-toggle/style.css";

import config from "../../app.json";
import axios from "axios";

import Pagination from "../../Components/Pagination/pagination";

import { Context } from "../../Reducers/Store";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import AlertComponent from "../../Components/AlertComponent";
import EventCard from "../../Components/EventCard/event-card";
import FieldSelect from "../../Components/Fields/FieldSelect";
import FieldDatepicker from "../../Components/Fields/FieldDatepicker";

function ListingEvents() {
  let navigate = useNavigate();
  const [state, dispatch] = useContext(Context);
  const [cards, setCards] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 8;

  const [channel, setChannel] = useState(null);
  const [channels, setChannels] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [stopDate, setStopDate] = useState(null);
  const [finishLoad, setFinishLoad] = useState(false);


  const handleFilter = () => {
    sessionStorage.removeItem("_events_channelId");
    sessionStorage.removeItem("_events_startDate");
    sessionStorage.removeItem("_events_stopDate");

    if (channel)
      sessionStorage.setItem("_events_channelId", JSON.stringify(channel));

    if (startDate)
      sessionStorage.setItem("_events_startDate", startDate.toISOString());

    if (stopDate)
      sessionStorage.setItem("_events_stopDate", stopDate.toISOString());

    if (currentPage == 0) {
      fetchEvents();
    }
    else
      setCurrentPage(0);
  }

  const fetchChannels = () => {
    axios.post(config.API + "/api/channel/getChannelsSelect").then((res) => {
      var parsed = res.data.$values?.map(x => { return { value: x.id, label: x.friendlyName || x.name } });
      setChannels(parsed);
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });
  };


  const fetchEvents = () => {
    if (!finishLoad)
      return;

    axios
      .post(config.API + "/api/event/getEvents", {
        page: currentPage,
        perPage: itemsPerPage,
        channelId: channel?.value,
        startDate,
        stopDate
      })
      .then((res) => {
        if (res.status === 200 && res.data) {
          if (res.data.values.$values.length) {
            setTotalItems(res.data.total);
          } else {
            setTotalItems(0);
          }
          res.data.values.$values.map((i) => {
            if (!window._channelsIds.includes(i.channelId))
              window._channelsIds.push(i.channelId);
          });

          setCards(res.data.values.$values);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message,
          { icon: `error` }
        );
      });
  };

  useEffect(() => {
    var channelLocalStorage = sessionStorage.getItem("_events_channelId");
    if (channelLocalStorage) setChannel(JSON.parse(channelLocalStorage));
    var startLocalStorage = sessionStorage.getItem("_events_startDate");
    if (startLocalStorage) setStartDate(new Date(startLocalStorage));
    var stopLocalStorage = sessionStorage.getItem("_events_stopDate");
    if (stopLocalStorage) setStopDate(new Date(stopLocalStorage));
    var currentPageLocalStorage = sessionStorage.getItem("_events_currentPage");
    if (currentPageLocalStorage) setCurrentPage(parseInt(currentPageLocalStorage, 10));

    fetchChannels();

    setFinishLoad(true);
  }, [0]);

  useEffect(() => {
    const totalPagesCalculated = Math.ceil(totalItems / itemsPerPage);
    setTotalPages(totalPagesCalculated);
  }, [totalItems]);

  useEffect(() => {
    sessionStorage.setItem("_events_currentPage", currentPage);
    fetchEvents();
  }, [currentPage, finishLoad]);

  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleNewEvent = () => {
    return navigate("/newEvent", { replace: false });
  };

  const paginationElement = cards && cards.length ? (
    <div className="pagination-container">
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onNextPage={nextPage}
        onPrevPage={prevPage}
      />
    </div>
  ) : null;

  return (
    <Row style={{ marginTop: 40 }}>
      <Col className="col-md-11">
        <Row className="filter">
          <Col md={12}>
            <div className="cc-card mb-4 p-4">
              <h5>Filter</h5>
              <Row>
                <Col md={3}>
                  <FieldSelect
                    label={`Channel`}
                    options={channels}
                    onChange={setChannel}
                    value={channel}
                    placeholder={`Channel`}
                    required={false}

                  />
                </Col>
                <Col md={2}>
                  <FieldDatepicker
                    label={`Start Date`}
                    className={`datepicker w-100`}
                    placeholder={`Start Date`}
                    value={startDate}
                    onChange={setStartDate}
                    startDate={startDate}
                    endDate={stopDate}
                    maxDate={stopDate}
                  />
                </Col>
                <Col md={2}>
                  <FieldDatepicker
                    label={`End Date`}
                    className={`datepicker w-100`}
                    placeholder={`Stop Date`}
                    value={stopDate}
                    onChange={setStopDate}
                    minDate={startDate}
                    startDate={startDate}
                  />
                </Col>
                <Col style={{ marginTop: 27, display: 'flex', justifyContent: 'flex-start', height: 52 }}>
                  <Button className="dark-btn btn btn-primary" type="button" onClick={handleFilter}>
                    Apply Filter
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>

        </Row>
        <Row>
          <Col className="col-md-12 mt-4 mb-3">
            {state.profile.role == "ROLE_CHURCH_ADMIN" &&

              <Button className="add-new-btn" onClick={handleNewEvent}>
                Add new
              </Button>
            }

          </Col>
        </Row>

        <Row className="listing-events-container">
          {cards?.map((x, index) => (
            <Col className="col-md-3 mb-4" key={"events_" + x.id}>
              <EventCard
                {...x}
                place={x.channelName}
                startDate={x.nextStart}
                index={index}
                listingEvent={true}
                deleteApiPath={`/api/event/deleteEvent`}
                manageApiPath={`/api/event/getEvent`}
                onDelete={fetchEvents}
                deleteMessage={`The Event has been successfully deleted`}
              />
            </Col>
          ))}
          {(!cards || !cards.length) && (
            <Col className="col-md-6">
              <div className="empty-state-card">
                There are no registered channels
              </div>
            </Col>
          )}

          {paginationElement}
        </Row>
      </Col>
    </Row>
  );
}

export default ListingEvents;
